import * as styles from "./VolunteerVacancySearch.module.scss";

import React, { useState } from "react";
import VolunteerVacancyResults from "../../components/VolunteerVacancyResults/VolunteerVacancyResults";
import { Button, Form } from "../../components/common";
import LocationInput from "../../containers/filters/LocationInput/LocationInput";
import { mapVolunteerVacancyToSignpostCard } from "../../utils/mappers";

interface Props {
	postcode?: string;
	vacancies: Queries.VolunteerVacancyDataFragment[];
}

const VolunteerVacancySearch: React.FC<Props> = ({ vacancies }) => {
	const [userLocation, setUserLocation] = useState<DogsTrust.Place | null>(
		null,
	);
	const [showResults, setShowResults] = useState(false);
	const onConfirmUserLocation = (userLoc: DogsTrust.Place) => {
		setUserLocation(userLoc);
	};
	const onClearUserLocation = () => setUserLocation(null);

	const onClick = () => {
		setShowResults(true);
	};

	return (
		<>
			<div className={styles.searchcontainer}>
				<h3 className={styles.title}>Your local roles</h3>
				<label htmlFor="inline-location-input" className={styles.label}>
					Location <span>(Postcode)</span>
				</label>
				<Form onSubmitFn={() => {}} validationSchema={{}}>
					<LocationInput
						name={"inline-location-input"}
						userLocation={userLocation}
						onConfirmUserLocation={onConfirmUserLocation}
						onClearUserLocation={onClearUserLocation}
						className={styles.searchinput}
						placeholder={"Postcode"}
						placeTypes={["locality", "sublocality", "postal_code"]}
					/>
				</Form>
				<Button
					onClick={onClick}
					fullWidth={true}
					disabled={!userLocation?.latitude && !userLocation?.longitude}
				>
					{`${
						!userLocation?.latitude && !userLocation?.longitude
							? "Enter your postcode"
							: "Show results"
					}`}
				</Button>
			</div>
			{showResults && (
				<div className={styles.vacancies}>
					{vacancies.length === 0 ? (
						<>
							<p className={styles.noresults}>
								<strong>
									Sorry there are no vacancies for this role near you right now.
								</strong>
							</p>
							<p className={styles.noresults}>
								Take a look at volunteering opportunities near you.
							</p>
							<p className={styles.noresults}>
								<a href="/support-us/volunteering/vacancies">
									Search all our volunteer vacancies
								</a>
							</p>
						</>
					) : (
						<VolunteerVacancyResults
							userLocation={userLocation}
							items={mapVolunteerVacancyToSignpostCard([...vacancies])}
						/>
					)}
				</div>
			)}
		</>
	);
};

export default VolunteerVacancySearch;
